import { CircularProgress } from "@material-ui/core";
import AppContext from "App.context";
import Layout from "components/Layout/Layout";
import LoadingScreen from "components/LoadingScreen/LoadingScreen";
import { IApis, getApis, loadEnvironments } from "library/Apis";
import { UserManager } from "oidc-client";
import CountdownProvider from "providers/CountdownProvider";
import React, { Suspense, useEffect, useState } from "react";
import { makeUserManager } from "react-oidc";
import { Provider } from "react-redux";
import { Router } from "react-router";
import { getStore, history } from "store/Store";
import { addGTag } from "utils/Gtag";
import { addHandTalk } from "utils/HandTalk";
import { getDomainIdByEnv, mapAppEnvToCookieEnv } from "utils/cookiesLGPDUtils";

export default function () {
  const [currentEnv, setCurrentEnv] = useState<IApis>();
  const [associadoManager, setUserManager] = useState<UserManager | null>(null);

  useEffect(() => {
    const getEnv = async () => {
      const env = (await loadEnvironments()) as IApis;
      setCurrentEnv(env);
      if (env.gtag) {
        addGTag();
      }
      if (env.handtalk) {
        addHandTalk();
      }
    };
    getEnv();

    const injectCookieLgpdManager = async () => {
      const env = ((await loadEnvironments()) as IApis).environment;
      const script = document.createElement("script");
      script.src =
        "https://web-static-stage.sicredi.io/lgpd-consentimento-coleta-cookies-lib@1/static/js/main.js";
      script.async = true;
      document.body.appendChild(script);
  
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href =
        "https://web-static-stage.sicredi.io/lgpd-consentimento-coleta-cookies-lib@1/static/css/main.css";
      document.head.appendChild(link);
  
      const div = document.createElement("div");
      div.id = "sicredi-cookies-root";
      div.setAttribute(
        "data-dominioUUID",
        getDomainIdByEnv(env)
      );
      div.setAttribute("data-enviroment", mapAppEnvToCookieEnv(env));
      document.body.appendChild(div);
    };
    injectCookieLgpdManager();
  }, []);

  useEffect(() => {
    if (currentEnv) {
      setUserManager(
        makeUserManager({
          ...currentEnv.authAssociado,
          automaticSilentRenew: true,
        })
      );
    }
  }, [currentEnv]);

  useEffect(() => {
    if (!associadoManager) return;
    associadoManager.events.addUserLoaded((user) => {
      window.localStorage.setItem("auth", user.id_token);
    });
  }, [associadoManager]);

  if (currentEnv && currentEnv.environment) {
    return (
      <Provider store={getStore(currentEnv.environment)}>
        <AppContext.Provider value={{ currentEnv, associadoManager }}>
          <Suspense fallback={<CircularProgress />}>
            <CountdownProvider>
              {getApis() && getApis().apis && (
                <Router history={history}>
                  <Layout />
                </Router>
              )}
            </CountdownProvider>
          </Suspense>
        </AppContext.Provider>
      </Provider>
    );
  }

  return <LoadingScreen />;
}
